<app-shell>

  <router-outlet>
  </router-outlet>
  <footer fxLayout="row" fxLayoutAlign="end center" id="footer">


    <p id="appVersion">v.{{appVersion}}</p>
    <span class="material-icons iconContainer" (click)="openChangelog()">
      info
    </span>
  </footer>

</app-shell>
